export const GWCA = Object.freeze({
  MAP: {
    '#my-account': 'dashboard',
    '#my-orders': 'orders',
    '#my-profile': 'profile',
    '#my-favorites': 'dashboard##favorites',
    '#order-': 'orders##order-detail',
    '#order-edit-': 'orders##order-edit',
  },

  STORAGE_KEYS: {
    TOKEN: 'i-shsgi--u0mihh3co1e3y9sns',
    EMAIL: 'gw-customer-accounts-email',
    RECENTLY_VIEWED: 'gw-recently-viewed',
    RECENTLY_VIEWED_COLLECTION: 'gw-recently-viewed-collection',
    YOTPO_POINTS: 'gw-yotpo-points',
    WISHLIST_PRODUCT_IDS: 'gw-wishlist-product-ids',
    RISE_POINTS: 'gw-rise-points',
    REDIRECT_URL: 'gw-customer-accounts-login-redirect',
    TEMP_WISHLIST_PRODUCTS: 'gw-temp-wishlist-products',
    TEMP_CART_PRODUCTS: 'gw-temp-cart-products',
    TEMP_RECENTLY_VIEWED_ITEMS: 'gw-temp-recently-viewed-items',
    TEMP_PRODUCTS_UPDATED: 'gw-temp-products-updated',
  },

  ENDPOINTS: {
    AUTH: {
      SIGN_IN: '/email-sign',
      SIGN_IN_TEST: '/email-sign-test',
      VERIFY_CODE: '/code-sign',
      GET_TOKEN: '/logged-sign',
      CUSTOMER_LOGGED: '/customer-logged',
      GET_CAPTCHA_TOKEN: '/get-token',
    },
    FAVORITES: {
      GET_ALL_IDS: '/get-all-favorites',
      GET: '/get-favorites',
      ADD: '/add-favorite',
      REMOVE: '/remove-favorite',
      ADD_BULK: '/add-favorites',
    },
    VIEWED_PRODUCTS: {
      GET: '/get-viewed-products',
      ADD: '/add-viewed-product',
      ADD_BULK: '/add-viewed-products',
    },
    CART: {
      GET: '/get-cart-products',
      ADD: '/add-cart-product',
      ADD_BULK: '/add-cart-products',
      REMOVE: '/remove-cart',
    },
    ADDRESS: {
      ADD: '/add-address',
      EDIT: '/edit-address',
      REMOVE: '/remove-address',
    },
    CUSTOMER: {
      UPDATE: '/update-customer',
    },
    LOYALTY: {
      GET_YOTPO_CUSTOMER: '/get-youtpo-customer',
      GET_RISE_CREDIT: '/get-rise-customer',
    },
    MISC: {
      GET_MALOMO_ORDER: '/get-malomo-order',
    },
  },

  TAGS_TO_HIDE: ['accounts:hidden'],

  TEMPLATE_IDS: {
    PRODUCT_CARD: 'gw-standard-product-card-template',
    FORM_PRODUCT_CARD: 'gw-form-product-card-template',
  },

  CUSTOM_EVENTS: {
    FAVORITES_STORAGE_UPDATED: 'gw:favorites-storage-updated',
    SAVED_ITEMS_FROM_CART: 'gw:saved-items-from-cart',
  },

  DRAWER_IDS: {
    favorites: '#Drawer-Favorites',
    'order-detail': '.order-detail-drawer',
    'order-edit': '.order-edit-drawer',
  },
});
